import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const MAX = 30;

export function useNavHistory() {
  const { pathname } = useLocation();
  const [stack, setStack] = useState<string[]>([pathname]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    setStack((prev) => {
      if (prev[idx] === pathname) return prev;
      const next = prev.slice(0, idx + 1);
      next.push(pathname);
      if (next.length > MAX) next.shift();
      return next;
    });
    setIdx((i) => Math.min(MAX - 1, i + 1));
  }, [pathname]);

  return {
    canBack: idx > 0,
    canForward: idx < stack.length - 1,
    back: () => {
      if (idx > 0) {
        const target = stack[idx - 1]!;
        setIdx(idx - 1);
        window.history.pushState({}, '', target);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    },
    forward: () => {
      if (idx < stack.length - 1) {
        const target = stack[idx + 1]!;
        setIdx(idx + 1);
        window.history.pushState({}, '', target);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }
    },
  };
}
